/**
 * Validate product purchase consent checkbox and show error message if not chekced
 */
document.addEventListener('DOMContentLoaded', () => {
    const checkbox = document.getElementById('product-consent-checkbox');
    const errorMsg = document.getElementById('consent-error-msg');
    const cartForm = document.querySelector('form.cart');
    const button = document.querySelector('.single_add_to_cart_button');

    if (!checkbox || !cartForm || !button || !errorMsg) {
        return;
    }

    const errorText = errorMsg.getAttribute('data-error-text');

    const updateAccessibilityState = () => {
        const isChecked = checkbox.checked;

        button.setAttribute('aria-disabled', !isChecked ? 'true' : 'false');

        if (isChecked) {
            button.classList.remove('-is-disabled');
            button.removeAttribute('aria-describedby');
            checkbox.removeAttribute('aria-invalid');
            errorMsg.textContent = '';
        } else {
            button.classList.add('-is-disabled');
        }
    };

    updateAccessibilityState();

    checkbox.addEventListener('change', updateAccessibilityState);

    cartForm.addEventListener('submit', (e) => {
        if (!checkbox.checked) {
            e.preventDefault();

            errorMsg.textContent = errorText;
            checkbox.setAttribute('aria-invalid', 'true');
            button.setAttribute('aria-describedby', 'consent-error-msg');
            errorMsg.setAttribute('tabindex', '-1');
            errorMsg.focus();
        }
    });
});
